<template>
    <div class="div-bg">
        <!-- <img src="../assets/images/login_bg.png" -->
        <!-- style="border: 0;width: 100%;height: 100%;position: absolute;left: 0;top: 0;right: 0;bottom: 0;z-index: -999;"> -->
        <div style="" ref="refLoginDiv" :style="{marginTop:panelMarginTop+'px'}">
            <div style="text-align: center;">
                <img src="../../assets/images/heng_dian.png" alt="" style="width: 270px;height: 55px;">
            </div>
            <div style="display: flex;justify-content: center;align-items: center;margin-top: 1em;">
                <el-card style="width: 620px;text-align: center;">
                    <p style="font-weight: bolder;font-size: 24px;text-align: center;margin-top: 40px;">欢迎注册恒点MOOL
                    </p>
                    <div style="padding-left: 90px;padding-right: 90px;">
                        <sub-email ref="subEmail" @emailSuccess="doNextStep" type="1"></sub-email>
                        <p style="text-align: left;font-size: 12px;margin-top: 25px;">
                            <el-checkbox label="我已阅读并同意" size="small" v-model="isRead"></el-checkbox>
                            <span @click="viewAgreement()"
                                  style="cursor: pointer;color:#00a4e0;">《恒点MOOL用户协议》</span>
                        </p>
                        <el-button type="primary" style="width: 400px;" @click="nextStep()">下一步</el-button>
                        <el-row style="color: #999999;margin-top: 10px;font-size: 12px;text-align: right;">
                            <span>已有账号？</span>
                            <router-link class="go-login" :to="{path:'/'}">登录</router-link>
                        </el-row>
                    </div>
                </el-card>
            </div>
        </div>
        <el-dialog title="恒点MOOL用户协议" :visible.sync="agreementIsShow">
            <sub-agreement></sub-agreement>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" size="mini" @click="read()">我已阅读并同意</el-button>
            </span>
        </el-dialog>
        <hd-footer></hd-footer>
    </div>
</template>

<script>
import HdFooter from '../public/Footer.vue'
import SubEmail from '../public/sub/SubEmail'
import SubAgreement from '../public/sub/SubAgreement'

export default {
    name: 'RegisterEmail',
    components: {
        HdFooter,
        SubEmail,
        SubAgreement
    },
    data () {
        return {
            panelMarginTop: 0,
            agreementIsShow: false,
            isRead: false,
            email: ''
        }
    },
    created () {

    },
    mounted () {
        this.$nextTick(function () {
            this.setPanelPosition()
        })
    },
    methods: {
        setPanelPosition: function () {
            let h = this.$refs.refLoginDiv.offsetHeight
            this.panelMarginTop = this.getClientTop(h)
        },
        setMobile () {

        },
        setSms (smsCode) {

        },
        viewAgreement: function () {
            this.agreementIsShow = true
        },
        read: function () {
            this.isRead = true
            this.agreementIsShow = false
        },
        nextStep: function () {
            //用户协议
            if (!this.isRead) {
                this.$message.error('请阅读并同意用户协议')
                return
            }
            //判断手机验证码是否正确
            this.$refs.subEmail.checkEmail()
        },
        /**
         * 组件SubEmail回调
         * @param cert
         */
        doNextStep (cert) {
            //跳转到新页面
            localStorage.setItem('cert', cert)
            this.$router.push({
                path: '/register-user'
            })
        }
    }
}
</script>

<style scoped="scoped">
.div-bg {
    background-image: url(../../assets/images/login_bg.png);
    border: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
}

.login-type-p {
    font-size: 16px;
    text-align: center;
}

.login-type-p span {
    cursor: pointer;
    padding-bottom: 3px;
}


.loginSelected {
    border-bottom: 1px solid #00a4e0;
    color: #00a4e0;
}

.formInput {
    width: 400px;
    margin-top: 25px;
}

.go-login {
    color: #00a4e0;
    text-decoration: none;
}

.checkAgreement {
    font-size: 12px;
}

.el-checkbox,
.el-checkbox__input,
.el-checkbox__label {
    font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/register/RegisterEmail.vue